/**
 * Споразумение за обработка на данни (DPA) — чл. 28 GDPR, за B2B клиенти на
 * „APP 4 FARMERS".
 */
import React from 'react';
import { LegalLayout } from './LegalLayout';
import { COMPANY, ContactBlock } from './company';

const DPAPage = () => (
  <LegalLayout title="Споразумение за обработка на данни (DPA)" active="/dpa">
    <div className="info-box">
      <h4>За кого е това споразумение?</h4>
      <p>
        Това Споразумение за обработка на данни (DPA) е предназначено за B2B клиенти (юридически
        лица), които използват {COMPANY.product} за управление на земеделска земя и въвеждат данни
        за свои служители, ползватели и контрагенти.
      </p>
    </div>

    <h2>1. Страни по споразумението</h2>
    <ul>
      <li><strong>Администратор на данни:</strong> Вашата организация (Клиент)</li>
      <li><strong>Обработващ лични данни:</strong> {COMPANY.name} (Доставчик)</li>
    </ul>

    <h2>2. Предмет и обхват</h2>
    <p>
      Това DPA урежда обработката на лични данни, която Доставчикът извършва от името на Клиента
      при предоставяне на Услугата {COMPANY.product} съгласно член 28 от GDPR.
    </p>

    <h2>3. Категории обработвани данни</h2>

    <h3>3.1. Категории субекти на данни</h3>
    <ul>
      <li>Служители на Клиента (потребители на платформата)</li>
      <li>Ползватели на земеделска земя — физически лица</li>
      <li>Лица, споменати в декларации, замени и контрагенти</li>
    </ul>

    <h3>3.2. Видове лични данни</h3>
    <ul>
      <li>Име и фамилия / наименование</li>
      <li>Имейл адрес и телефонен номер (когато са въведени)</li>
      <li>Име на фирма/организация, ЕИК/Булстат</li>
      <li>Данни за землища, площи, декларации и замени</li>
    </ul>

    <h2>4. Цел и продължителност на обработката</h2>
    <ul>
      <li><strong>Цел:</strong> предоставяне на Услугата {COMPANY.product} за управление на земеделска земя и доброволни замени</li>
      <li><strong>Продължителност:</strong> за периода на активен договор + 30 дни след прекратяване</li>
    </ul>

    <h2>5. Задължения на Доставчика</h2>
    <p>Доставчикът се задължава да:</p>
    <ul>
      <li>обработва данните само по документирани инструкции от Клиента;</li>
      <li>гарантира, че лицата, обработващи данните, са обвързани с конфиденциалност;</li>
      <li>прилага подходящи технически и организационни мерки за сигурност;</li>
      <li>не ангажира под-обработващи без предварително разрешение;</li>
      <li>съдейства на Клиента при искания от субекти на данни;</li>
      <li>съдейства при оценки на въздействието (DPIA);</li>
      <li>изтрие или върне данните след прекратяване на договора;</li>
      <li>предоставя информация за демонстриране на съответствие.</li>
    </ul>

    <h2>6. Мерки за сигурност</h2>

    <h3>6.1. Технически мерки</h3>
    <ul>
      <li>Криптиране на връзките (HTTPS/TLS)</li>
      <li>Съхранение на паролите само в хеширан вид</li>
      <li>Контрол на достъпа по роли и по землища</li>
      <li>Журнал на действията в системата</li>
      <li>Резервни копия на данните</li>
      <li>Защитен хостинг в Европейския съюз</li>
    </ul>

    <h3>6.2. Организационни мерки</h3>
    <ul>
      <li>Контрол на достъпа, базиран на роли (RBAC)</li>
      <li>Журнал на достъпа и действията</li>
      <li>Процедури за реагиране при инциденти</li>
      <li>Достъп, ограничен до упълномощени лица</li>
    </ul>

    <h2>7. Под-обработващи (Субпроцесори)</h2>
    <p>Клиентът дава общо разрешение за следните под-обработващи:</p>
    <table>
      <thead>
        <tr>
          <th>Име</th>
          <th>Местоположение</th>
          <th>Цел</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{COMPANY.hosting}</td>
          <td>{COMPANY.hostingLocation}</td>
          <td>Хостинг и съхранение на данни</td>
        </tr>
      </tbody>
    </table>
    <p>
      Доставчикът ще уведоми Клиента за промени в под-обработващите 30 дни предварително.
      Клиентът може да възрази в този срок.
    </p>

    <h2>8. Трансфер на данни извън ЕС</h2>
    <p>
      Данните се хостват в дата центрове в ЕС ({COMPANY.hostingLocation}). Тъй като хостинг
      доставчикът ({COMPANY.hosting}) е със седалище в САЩ, при евентуален достъп от негова страна
      се прилагат подходящи защитни мерки съгласно Глава V от GDPR:
    </p>
    <ul>
      <li>Стандартни договорни клаузи (SCC)</li>
      <li>EU-US Data Privacy Framework (DPF), когато е приложимо</li>
    </ul>

    <h2>9. Нарушения на сигурността</h2>
    <p>При нарушение на сигурността на данните Доставчикът ще:</p>
    <ul>
      <li>уведоми Клиента без неоснователно забавяне (не по-късно от 48 часа);</li>
      <li>предостави информация за естеството на нарушението;</li>
      <li>опише вероятните последици;</li>
      <li>опише предприетите или предложени мерки;</li>
      <li>съдейства при уведомяването на надзорния орган и субектите на данни.</li>
    </ul>

    <h2>10. Права на субектите на данни</h2>
    <p>Доставчикът ще съдейства на Клиента при отговаряне на искания за:</p>
    <ul>
      <li>достъп до данни;</li>
      <li>коригиране на данни;</li>
      <li>изтриване на данни;</li>
      <li>ограничаване на обработката;</li>
      <li>преносимост на данни;</li>
      <li>възражение срещу обработка.</li>
    </ul>

    <h2>11. Одит</h2>
    <p>
      Клиентът има право да извършва одити или да ангажира одитор за проверка на съответствието с
      това DPA. Доставчикът ще предостави необходимата информация при разумно предизвестие.
    </p>

    <h2>12. Изтриване на данни</h2>
    <p>След прекратяване на договора Доставчикът ще:</p>
    <ul>
      <li>позволи изтегляне на данни за период от 30 дни;</li>
      <li>изтрие всички данни след изтичане на периода;</li>
      <li>предостави потвърждение за изтриването при поискване.</li>
    </ul>

    <h2>13. Отговорност</h2>
    <p>
      Всяка страна носи отговорност за вреди, причинени от нейни нарушения на GDPR. Доставчикът
      носи отговорност само ако не е изпълнил задълженията по GDPR, специфични за обработващите,
      или е действал извън законните инструкции на Клиента.
    </p>

    <h2>14. Приложимо право</h2>
    <p>
      Това DPA се урежда от българското право. Спорове се разрешават от компетентния съд по
      седалището на Доставчика.
    </p>

    <h2>15. Контакт</h2>
    <ContactBlock title="За въпроси относно обработката на данни" />

    <div className="info-box">
      <h4>Приемане на DPA</h4>
      <p>
        При сключване на договор като B2B клиент и отбелязване на съответното поле Вие приемате
        условията на това Споразумение за обработка на данни от името на Вашата организация.
      </p>
    </div>
  </LegalLayout>
);

export default DPAPage;
